/**
 * Hero Carousel Component
 * Gerencia o carrossel do Hero com autoplay, navegação e controles
 */
class HeroCarousel {
  constructor() {
    this.hero = document.querySelector('.hero');
    if (!this.hero) return;

    this.slides = this.hero.querySelectorAll('.hero__slide');
    this.contentSlides = this.hero.querySelectorAll('.hero__content-slide');
    this.dots = this.hero.querySelectorAll('.hero__dot');
    this.prevBtn = this.hero.querySelector('.hero__control--prev');
    this.nextBtn = this.hero.querySelector('.hero__control--next');
    
    this.currentSlide = 0;
    this.totalSlides = this.slides.length;
    this.autoplaySpeed = parseInt(this.hero.dataset.autoplaySpeed) || 5000;
    this.autoplayInterval = null;
    this.isTransitioning = false;

    this.init();
  }

  init() {
    if (this.totalSlides <= 1) return;

    this.setupEventListeners();
    this.startAutoplay();
    this.updateSlideVisibility();
  }

  setupEventListeners() {
    // Controles de navegação
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.previousSlide());
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.nextSlide());
    }

    // Dots de navegação
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    // Pausar autoplay ao passar o mouse
    this.hero.addEventListener('mouseenter', () => this.pauseAutoplay());
    this.hero.addEventListener('mouseleave', () => this.startAutoplay());

    // Pausar autoplay quando a página não está visível
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.pauseAutoplay();
      } else {
        this.startAutoplay();
      }
    });
  }

  goToSlide(index) {
    if (this.isTransitioning || index === this.currentSlide) return;

    this.isTransitioning = true;
    this.pauseAutoplay();

    // Pausar vídeo do slide atual se existir
    const currentSlideVideo = this.slides[this.currentSlide].querySelector('.hero__background-video');
    if (currentSlideVideo) {
      currentSlideVideo.pause();
    }

    // Remover classe ativa do slide atual
    this.slides[this.currentSlide].classList.remove('hero__slide--active');
    this.dots[this.currentSlide]?.classList.remove('hero__dot--active');
    this.contentSlides[this.currentSlide]?.classList.remove('hero__content-slide--active');

    // Atualizar slide atual
    this.currentSlide = index;

    // Adicionar classe ativa ao novo slide
    this.slides[this.currentSlide].classList.add('hero__slide--active');
    this.dots[this.currentSlide]?.classList.add('hero__dot--active');
    this.contentSlides[this.currentSlide]?.classList.add('hero__content-slide--active');

    // Iniciar vídeo do novo slide se existir
    const newSlideVideo = this.slides[this.currentSlide].querySelector('.hero__background-video');
    if (newSlideVideo) {
      newSlideVideo.muted = true;
      newSlideVideo.volume = 0;
      newSlideVideo.play().catch((error) => {
        console.warn('[Hero Carousel] Erro ao iniciar vídeo:', error);
      });
      
      // Esconder poster se existir
      const poster = this.slides[this.currentSlide].querySelector('.hero__background-video-poster');
      if (poster) {
        poster.style.opacity = '0';
        setTimeout(() => {
          poster.style.display = 'none';
        }, 500);
      }
    }

    // Resetar flag de transição após animação
    setTimeout(() => {
      this.isTransitioning = false;
      this.startAutoplay();
    }, 500);
  }

  nextSlide() {
    const nextIndex = (this.currentSlide + 1) % this.totalSlides;
    this.goToSlide(nextIndex);
  }

  previousSlide() {
    const prevIndex = this.currentSlide === 0 ? this.totalSlides - 1 : this.currentSlide - 1;
    this.goToSlide(prevIndex);
  }

  startAutoplay() {
    if (this.totalSlides <= 1) return;

    this.pauseAutoplay();
    this.autoplayInterval = setInterval(() => {
      this.nextSlide();
    }, this.autoplaySpeed);
  }

  pauseAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }

  updateSlideVisibility() {
    this.slides.forEach((slide, index) => {
      if (index === this.currentSlide) {
        slide.classList.add('hero__slide--active');
      } else {
        slide.classList.remove('hero__slide--active');
      }
    });

    this.dots.forEach((dot, index) => {
      if (index === this.currentSlide) {
        dot.classList.add('hero__dot--active');
      } else {
        dot.classList.remove('hero__dot--active');
      }
    });

    this.contentSlides.forEach((cs, index) => {
      if (index === this.currentSlide) {
        cs.classList.add('hero__content-slide--active');
      } else {
        cs.classList.remove('hero__content-slide--active');
      }
    });
  }

  // Método público para controle externo
  destroy() {
    this.pauseAutoplay();
    // Remover event listeners se necessário
  }
}

// Inicializar quando o DOM estiver pronto
document.addEventListener('DOMContentLoaded', () => {
  new HeroCarousel();
});

// Exportar para uso em outros módulos se necessário
window.HeroCarousel = HeroCarousel;
